var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 63,
    viewBox: "0 0 121 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_6524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 18,
    width: 121,
    height: 26
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_6524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.01 26.0373C100.805 21.6115 97.8716 18.5605 91.3517 18.5605C85.4857 18.5605 81.1703 21.0842 81.189 26.1126C81.2077 34.4933 94.8452 31.4047 95.0507 36.2448C95.1067 37.5631 93.4067 38.3541 91.4825 38.3541C90.7353 38.3541 89.5396 38.1658 88.9231 37.7703C88.2693 37.3748 87.8209 36.3766 87.522 35.0207H80.5352C80.6286 40.4069 84.8693 43.4391 91.0528 43.4391C97.4979 43.4391 101.664 40.9154 101.72 35.435C101.813 27.2426 87.7836 28.9564 87.7836 25.4911C87.7836 23.6266 89.2781 23.2688 90.9781 23.2688C91.7254 23.2688 92.4166 23.4006 92.9583 23.702C93.5188 24.0033 94.3034 25.2463 94.4342 26.0749H101.01V26.0373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.202 42.893V35.3974H119.73V29.8793H110.202V25.2087H121V19.1821H103.141V42.893H110.202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62096 36.4329C10.4051 36.4329 11.0408 35.7921 11.0408 35.0016C11.0408 34.2111 10.4051 33.5703 9.62096 33.5703C8.83683 33.5703 8.20117 34.2111 8.20117 35.0016C8.20117 35.7921 8.83683 36.4329 9.62096 36.4329Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8183 41.3486C23.426 41.9136 22.9963 42.3656 22.5293 42.8929H23.8183V41.3486Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0371094 29.3707C1.9613 25.9995 5.52947 23.7019 9.62071 23.7019C15.7296 23.7019 20.2692 28.4855 19.5032 35.1147C18.9988 39.4087 15.8043 42.0265 12.1988 42.8928H15.9537C19.0175 40.9907 21.3714 37.8267 21.3153 33.7964C21.3153 27.5627 17.5417 23.2311 11.8064 22.3647V23.0804H5.09979C3.11955 23.8526 1.38218 25.1144 0.0371094 26.734V29.3707Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0195312 36.9793C0.523931 39.4276 1.90636 41.4616 3.83055 42.8741H7.39872C3.96133 41.9136 1.42064 38.7873 1.42064 35.0018C1.42064 30.4442 5.08221 26.6211 9.62182 26.6211C14.1427 26.6211 16.7021 30.0111 16.5713 33.9848C16.5153 37.9021 13.0592 40.5388 9.62182 40.5199C6.59541 40.5011 4.12946 38.034 4.12946 34.983C4.12946 31.932 6.59541 29.4461 9.62182 29.4461C12.6482 29.4461 15.5065 32.2145 14.9834 35.8117C16.534 31.706 13.5262 27.8453 9.62182 27.8453C5.6987 27.8453 2.54153 31.0469 2.54153 34.983C2.54153 38.9191 5.71739 42.1207 9.62182 42.1207C13.5449 42.1207 18.0845 39.0133 18.2153 34.418C18.4582 28.7304 15.0208 25.0015 9.62182 25.0015C4.87672 25.0203 0.934924 28.4856 0.0195312 33.0055V36.9793Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83079 42.893C1.12089 42.1962 0.523082 41.4993 0 40.6519V42.893H1.83079Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8438 20.99C18.3075 21.9129 22.679 26.9036 22.679 33.853C22.6603 37.7515 20.9043 40.7836 18.4196 42.8929H20.5493C22.0065 41.4616 23.2768 39.729 23.8186 37.6762V29.6721C22.3614 24.5118 18.1768 20.1237 11.8438 19.3516V20.99Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0664 18.9751C19.4104 20.1427 22.5115 23.1372 23.8192 26.0563V23.4009C22.7544 21.7624 21.2972 20.1992 19.4851 18.9939L16.0664 18.9751Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 18.9939C22.1381 19.2953 23.5392 20.7454 23.8194 21.2162V18.9751L21.6523 18.9939Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.0239V24.9826C0.653852 24.1162 1.92419 23.2876 2.39123 23.0239H0Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31302 19.9728C8.3317 19.8598 8.29434 19.5585 8.1262 19.3513C7.8273 18.9558 7.22949 18.937 7.06136 18.937C6.27673 18.937 5.9031 19.3137 5.86574 19.8222C5.8097 20.3495 6.08992 20.5943 6.44487 20.7073C6.85586 20.858 7.49103 20.858 7.69653 21.0652C7.84598 21.2158 7.8273 21.4795 7.67785 21.6113C7.60312 21.6866 7.39762 21.762 7.17345 21.762C6.94927 21.762 6.72509 21.7243 6.57564 21.5736C6.46355 21.4606 6.44487 21.3288 6.44487 21.2346H5.79102C5.8097 21.536 5.95915 21.8561 6.23937 22.0633C6.48223 22.2328 6.85586 22.2893 7.02399 22.2893C7.37894 22.2893 7.75257 22.2328 8.03279 22.0633C8.42511 21.7996 8.61192 21.0463 8.23829 20.6508C8.03279 20.4437 7.65916 20.3683 7.49103 20.3307C7.36026 20.3118 6.76245 20.2177 6.68773 20.1235C6.53828 20.067 6.46355 20.0293 6.48223 19.8033C6.50091 19.5397 6.74377 19.4267 7.06136 19.4267C7.50971 19.4267 7.73389 19.6715 7.71521 19.9352H8.31302V19.9728Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94922 18.9937V22.2141H9.60307V21.0276H10.836V20.4626H9.60307V19.5398H11.0976V18.9937H8.94922Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3648 30.4255C53.8593 29.465 55.6154 28.222 55.6154 25.3029C55.6154 20.6134 51.5989 19.1821 46.312 19.1821H35.7383V42.893H46.5549C52.645 42.893 56.9044 41.2357 56.9044 35.9436C56.9044 32.6666 54.9055 31.0846 52.3648 30.4255ZM42.7999 24.7002H46.3494C47.9747 24.7002 49.3197 24.8886 49.3197 26.7342C49.3197 28.109 48.367 28.6363 46.8351 28.6363H42.7999V24.7002ZM47.0406 37.6762H42.7999V33.1186H46.1252C48.5725 33.1186 50.1043 33.1939 50.1043 35.2467C50.1043 37.0359 48.9274 37.6762 47.0406 37.6762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7635 19.1821H64.936L56.5293 42.893H63.6843L64.6931 39.39H72.8569L73.8284 42.893H81.1702L72.7635 19.1821ZM66.1503 34.4558L68.7283 25.736L71.3811 34.4558H66.1503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16705 20.5003C2.39123 20.312 2.46596 20.0295 2.46596 19.8411C2.46596 19.7093 2.40991 18.9937 1.3077 18.9937H0V22.2141H1.43847C1.64397 22.2141 1.99892 22.1764 2.2231 21.9881C2.50332 21.7433 2.55936 21.4796 2.55936 21.3101C2.55936 20.9335 2.37255 20.651 2.16705 20.5003ZM0.653852 19.5398H1.43847C1.66265 19.5398 1.84947 19.634 1.84947 19.8976C1.84947 20.1613 1.68133 20.2555 1.40111 20.2555H0.653852V19.5398ZM1.43847 21.6679H0.653852V20.8393H1.55056C1.68133 20.8393 1.92419 20.8581 1.92419 21.216C1.92419 21.6491 1.62529 21.6679 1.43847 21.6679Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59581 18.9937H3.82987L2.70898 22.2141H3.38152L3.6057 21.5738H4.78263L5.00681 22.2141H5.67934L4.59581 18.9937ZM3.81119 21.0088L4.2035 19.7658L4.63318 21.0088H3.81119Z",
    fill: "#ED1C24"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_6524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.91602,
    y: -4.05615,
    width: 136.832,
    height: 71.243,
    fill: "#B3BACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_6524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 24.8785,
    fill: "white",
    transform: "translate(0 18.5605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner9);
export default __webpack_public_path__ + "static/media/partner-9.4144d6e93145aee26bea01bac99b935d.svg";
export { ForwardRef as ReactComponent };